export function optionLabel(options: any[], value: any) {
  return options.find((t: { value: any }) => t.value === value)?.label;
}

export function optionWithGroupLabel(
  groups: any[],
  value: any,
  country?: string
) {
  for (const group of groups) {
    if (group.options === undefined) continue;

    const foundOption = group.options.find(
      (option: { value: any; country: any }) =>
        option.value === value &&
        (country === undefined || option.country === country)
    );
    if (foundOption) {
      return foundOption.label;
    }
  }
  return undefined;
}
